import { Component } from '@angular/core';

@Component({
    selector: 'app-questionnaire-footer',
    templateUrl: './questionnaire-footer.component.html',
    styleUrls: ['./questionnaire-footer.component.scss'],
    standalone: false
})
export class QuestionnaireFooterComponent {}
